/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Overwrite_TextInputs */

const en_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to overwrite "${i?.name}"?`)
};

const fr_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir ecraser "${i?.name}" ?`)
};

const de_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich überschreiben?`)
};

const it_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler sovrascrivere "${i?.name}"?`)
};

const ru_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите перезаписать "${i?.name}"?`)
};

const es_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea sobrescribir "${i?.name}"?`)
};

const zh_cn2_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要覆盖“${i?.name}”吗？`)
};

const ja_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を上書きしてもよろしいですか?`)
};

const hi_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.name}" को ओवरराइट करना चाहते हैं?`)
};

const pt_pt2_explorer_info_overwrite_text = /** @type {(inputs: Explorer_Info_Overwrite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja sobrescrever "${i?.name}"?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to overwrite \"{name}\"?" |
*
* @param {Explorer_Info_Overwrite_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_overwrite_text = /** @type {((inputs: Explorer_Info_Overwrite_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Overwrite_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_overwrite_text(inputs)
	if (locale === "de") return de_explorer_info_overwrite_text(inputs)
	if (locale === "it") return it_explorer_info_overwrite_text(inputs)
	if (locale === "ru") return ru_explorer_info_overwrite_text(inputs)
	if (locale === "es") return es_explorer_info_overwrite_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_overwrite_text(inputs)
	if (locale === "ja") return ja_explorer_info_overwrite_text(inputs)
	if (locale === "hi") return hi_explorer_info_overwrite_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_overwrite_text(inputs)
	return en_explorer_info_overwrite_text(inputs)
});